import React from 'react';

import imgLogo from 'assets/images/logo.svg';
import imgBgHeader from 'assets/images/bg-header.png';
import SearchAddress from 'components/SearchAddress/SearchAddress';

import './Header.scss';

type TypeProps = {
  setCenterMap: (centerLatLng: [number, number]) => void;
  resetClicked: number;
  setResetClicked: (reset: number) => void;
};

const Header = ({ setCenterMap, resetClicked, setResetClicked }: TypeProps) => {
  return (
    <div
      className="header"
      style={{ backgroundImage: `url("${imgBgHeader}")` }}
    >
      <div className="logo-description">
        <div className="logo-wrapper">
          <a
            href="https://southeastwater.com.au"
            target="_blank"
            rel="noreferrer"
          >
            <img className="logo" src={imgLogo} alt="Logo" />
          </a>
        </div>
        <div className="info">
          <h4>Interactive map</h4>
          <p>
            Explore the South East Water projects through our interactive map
            and find out what is happening near you.
          </p>
        </div>
      </div>

      <SearchAddress
        setCenterMap={(centerLatLng) => setCenterMap(centerLatLng)}
        resetClicked={resetClicked}
        setResetClicked={(reset) => setResetClicked(reset)}
      />
    </div>
  );
};

export default Header;
